import { openModal } from "../../ui/containers/Modal";
import { ComponentF, createElement } from "../../ui/ui";
import Colors from "../Colors";
import { gameData } from "../GameManager";
import { HelpModal } from "./home/HelpModal";

export const TopInfo: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  C.display.drawText(
    C.bounds.x + 5,
    C.bounds.y,
    `Depth ${gameData.current.depth} of 5`
  );

  C.display.drawText(
    C.bounds.x + C.bounds.w - 11,
    C.bounds.y,
    `%c{${Colors.RED_4}}?%c{} Help`
  );

  C.handlers.keypress = (key) => {
    if (key === "/" || key === "?") {
      openModal(createElement(HelpModal, { x: 0, y: 0, w: 78, h: 46 }));
      return true;
    }
    return false;
  };
};
